import * as React from 'react';
import { Box } from 'grommet';

export function ModalDivider() {
  return <Box fill="horizontal" height="2px" background="nl-lilac-600" margin={{ vertical: '5px' }} />;
}
